module.exports = __webpack_public_path__ + "media/newstyle/images/mastercard-c38012a7626c165d92d3c5b03155fc75.svg";